import { useTranslation } from 'react-i18next';
import { Tabs } from '@/components';
import { enumObject } from '@/utils';
import { RoomListTabPanel } from '@/views/Rooms.List/RoomListTabPanel';
import { RoomCategory } from '@/core';
import { UpdateWholeHomeFloorplanArgs } from '@/redux';
import { FloorplanGeoItemsList } from './FloorplanGeoItemsList';

const TAB_KEYS = ['home-categories', 'floorplan-items'] as const;

const FloorplanDetailsTabKeys = enumObject('FloorplanDetailsTabKeys', TAB_KEYS);

const { TabPane } = Tabs;

interface Props {
  communityId: string;
  floorplanId: string;
  wholeHomeSquareFootage: number;
  wholeHomeCategories: RoomCategory[] | undefined;
  onWholeHomeUpdate?: (value: UpdateWholeHomeFloorplanArgs) => Promise<void>;
}

export function FloorplanDetailsTabsPanel(props: Props) {
  const {
    communityId,
    floorplanId,
    wholeHomeSquareFootage,
    wholeHomeCategories,
    onWholeHomeUpdate,
  } = props;
  const { t } = useTranslation();
  return (
    <Tabs tabKeys={FloorplanDetailsTabKeys} destroyInactiveTabPane>
      <TabPane
        tab={t('floorplans.details.homeCategories')}
        key={FloorplanDetailsTabKeys['home-categories']}
      >
        <RoomListTabPanel
          communityId={communityId}
          floorplanId={floorplanId}
          wholeHomeSquareFootage={wholeHomeSquareFootage}
          wholeHomeCategories={wholeHomeCategories}
          onWholeHomeUpdate={onWholeHomeUpdate}
        />
      </TabPane>
      <TabPane
        tab={t('floorplans.details.items')}
        key={FloorplanDetailsTabKeys['floorplan-items']}
      >
        <FloorplanGeoItemsList
          floorplanId={floorplanId}
          communityId={communityId}
        />
      </TabPane>
    </Tabs>
  );
}
